import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon, CheckIcon, LockIcon } from 'lucide-react';
import { event } from '../data/masterclass';
type EnrollFlowProps = {
  paid: boolean;
  onPay: () => void;
  size?: 'lg' | 'md';
};
const EASE = [0.23, 1, 0.32, 1] as const;
export function EnrollFlow({
  paid,
  onPay,
  size = 'lg'
}: EnrollFlowProps) {
  const pad = size === 'lg' ? 'px-9 py-5 text-base' : 'px-7 py-4 text-sm';
  return <div className="w-full max-w-xl text-center" data-id="element-42" data-mp="2qzua1ibvvdk4">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-stretch" data-id="element-43" data-mp="2m6stz6zxx7yy">
        <a href={event.payUrl} target="_blank" rel="noopener noreferrer" onClick={onPay} className={`group inline-flex flex-1 items-center justify-center gap-2 rounded-full bg-gold font-semibold uppercase tracking-[0.16em] text-ink transition-[transform,background-color,box-shadow] duration-200 ease-out hover:bg-gold-pale focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold active:scale-[0.98] ${pad}`} data-id="element-44" data-mp="2h7oho7hpyu4e">
          {paid ? 'Return to checkout' : 'Reserve my seat'}
          <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-45" data-mp="1kiz7bbt8p6mp" />
        </a>

        <a href={paid ? event.registerUrl : undefined} target="_blank" rel="noopener noreferrer" aria-disabled={!paid} tabIndex={paid ? 0 : -1} onClick={e => {
        if (!paid) e.preventDefault();
      }} className={`inline-flex flex-1 items-center justify-center gap-2 rounded-full border font-semibold uppercase tracking-[0.16em] transition-[color,border-color,background-color] duration-200 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold ${pad} ${paid ? 'border-gold text-gold hover:bg-gold hover:text-ink' : 'pointer-events-none border-white/12 text-white/35'}`} data-id="element-46" data-mp="1bp2l5x02ru7a">
          {paid ? <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-47" data-mp="3r2mu7cbr712g" /> : <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-48" data-mp="3m9tp2ncdhqpu" />}
          Register on Zoom
        </a>
      </div>

      <div className="mt-4 min-h-[1.25rem]" aria-live="polite" data-id="element-49" data-mp="3h9xoky2vwhf1">
        <AnimatePresence mode="wait" initial={false} data-id="element-50" data-mp="3ce09ev3cxh3u">
          <motion.p key={paid ? 'paid' : 'unpaid'} initial={{
          opacity: 0,
          y: 6
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -6
        }} transition={{
          duration: 0.22,
          ease: EASE
        }} className="text-sm leading-relaxed text-white/55" data-id="element-51" data-mp="37ducazebj2ed">
            {paid ? <span className="text-gold-pale" data-id="element-52" data-mp="11jkvt3l89ynv">
                Payment tab opened — finish checkout, then register on Zoom to get
                your join link.
              </span> : <>
                Step 1: complete payment. Step 2 unlocks your Zoom registration.
              </>}
          </motion.p>
        </AnimatePresence>
      </div>
    </div>;
}